var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadBigIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    d: "M.001 0h16.998v17H.001V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M3.001 16v-1h10.998v1H3.001zm5.998-3h-.691l-.03.03-.029-.03H8v-.248L3.743 8.494l.708-.707L8 11.337V1h.999v10.298l3.542-3.542.708.707-4.25 4.249V13z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBigIcon);
export default __webpack_public_path__ + "static/media/download-big-icon.a17067b2e21aadbf842e83822b8ce76c.svg";
export { ForwardRef as ReactComponent };